import { Subject } from 'rxjs';

const subject = new Subject();

export const deleteAccountTourGuideService = {
    emitReload: val => subject.next(val),
    reload: () => subject.asObservable()
};